import { render, staticRenderFns } from "./SlcShortcutsProvider.vue?vue&type=template&id=3ff13a22&"
import script from "./SlcShortcutsProvider.vue?vue&type=script&lang=ts&"
export * from "./SlcShortcutsProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports